import BlockTypes from '../../../types/BlockTypes';

function isCell(cell) {
  return cell && cell.type === BlockTypes.TABLE_CELL;
}

export default function isValidSelectionRange(editor, _ref) {
  var start = _ref.start,
      end = _ref.end;
  return start !== end && isCell(start) && isCell(end) && start.getIn(['data', 'tableId']) === end.getIn(['data', 'tableId']);
}